<template>
  <div>
    Assurance Crédit
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'AssuranceCredit'
}
</script>
